import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getEventIdFromSlug } from 'utils/events';
import { fetchEventWithTickets } from './slice';
import { useSelector } from 'react-redux';
import { selectCartUUID } from 'store/cartSlice/selectors';

const useEventWithTickets = ({
  extraIncludes = [],
}: {
  extraIncludes: string[];
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eventSlug } = useParams();
  const eventId = getEventIdFromSlug(eventSlug);
  const uuid = useSelector(selectCartUUID);
  // support for getting data only about the searched tickets
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchData = async () => {
      const dispatchData = await dispatch(
        fetchEventWithTickets({
          eventId,
          queryParams: {
            uuid,
            tickets: searchParams.get('tickets'),
            preview: searchParams.get('preview'),
          },
          extraIncludes,
        }),
      );
      if (!dispatchData?.payload?.id) {
        navigate('/404');
        return;
      }
    };
    fetchData();
  }, []);

  return null;
};

export default useEventWithTickets;
